import { render } from "./AuthLayout.vue?vue&type=template&id=32ab224c"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
script.render = render

export default script